import * as API from "@/endpoints";
import Vue from "vue";
import Axios from "axios";


export default {
  namespaced: true,
  state: {
    uploadedImage: null,
    multipleImage: [],
    imageUploadLoader: false,
    currentGeoLocation: {},
    geoPermission: null,
    attachement: null,
    attachementLoader: false,
    hasAttachement: false,
    cities: [],
    provinces: [],
    showPostItemModal: false,
    showGroup: false,
    showAboutMynd: false
  },
  mutations: {
    setUploadedImage (state, v) {
      Vue.set(state, 'uploadedImage', v)
    },
    setImageUploadLoader (state, v) {
      Vue.set(state, 'imageUploadLoader', v)
    },
    setCurrentGeoLocation (state, v) {
      Vue.set(state, 'currentGeoLocation', v)
    },
    setGeoPermission (state, v) {
      Vue.set(state, 'geoPermission', v)
    },
    setAttachement (state, v) {
      Vue.set(state, 'attachement', v)
    },
    setAttachementLoader (state, v) {
      Vue.set(state, 'attachementLoader', v)
    },
    setHasAttachement (state, v) {
      Vue.set(state, 'hasAttachement', v)
    },
    setMultipleImage (state, v) {
      state.multipleImage.push(v)
    },
    removeMultipleImage (state) {
      Vue.set(state, 'multipleImage', [])
    },
    removeSIngleImage (state, v) {
      state.multipleImage.splice(v, 1)
    },
    setCities (state, v) {
      Vue.set(state, 'cities', v)
    },
    emptyCities (state, v) {
      Vue.set(state, 'cities', [])
    },
    setProvinces (state, v) {
      Vue.set(state, 'provinces', v)
    },
    emptyProvinces (state) {
      Vue.set(state, 'provincces', [])
    },
    setShowPostItemModal (state, v) {
      Vue.set(state, 'showPostItemModal', v)
    },
    setShowGroup (state, v) {
      Vue.set(state, 'showGroup', v)
    },
    setShowAboutMynd (state, v) {
      Vue.set(state, 'showAboutMynd', v)
    }
  },
  actions: {
    onLoadModuleCitation(context, payload) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.item + "/" + payload).then(
          res => {
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    uploadBase64Image({ commit, dispatch, state }, payload) {
      commit('setImageUploadLoader', true)
      return new Promise((resolve, reject) => {
        Axios.post(API.endpoints.uploadBase64Img, payload).then(
          res => {
            commit('setImageUploadLoader', false)
            commit('setUploadedImage', res.data)
            resolve(res.data)
          },
          error => {
            commit('setImageUploadLoader', false)
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    uploadMultipleImage ({ commit, dispatch, state }, payload) {
      commit('setImageUploadLoader', true)

      let i = 0
      return new Promise((resolve, reject) => {
        uploadImage().then(res => {
          commit('setImageUploadLoader', false)
          resolve(res.data)
        }, error => {
          reject(error)
        })
      })

      function uploadImage () {
        return Axios.post(API.endpoints.uploadBase64Img, {base64_image: payload[i++]}).then(
          res => {
            commit('setMultipleImage', res.data)
            if (i < payload.length) {
              return uploadImage()
            } else {
              return Promise.resolve(res.data)
            }
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            return Promise.reject(error)
          }
        )
      }
    },
    scrapeUrl ({ commit, dispatch, state }, payload) {
      commit('setAttachementLoader', true)
      return new Promise((resolve, reject) => {
        Axios.get(process.env.VUE_APP_API + payload).then(
          res => {
            console.log(res.data)
            commit('setAttachement', res.data)
            commit('setAttachementLoader', false)
            commit('setHasAttachement', true)
            resolve(res.data)
          },
          error => {
            commit('setAttachementLoader', false)
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    cities ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        Axios(API.endpoints.cities + '?country_code=' + payload.country_code + '&region_code=' + payload.region_code + '&search=' + payload.value).then(
          res => {
            commit('setCities', res.data)
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            return Promise.reject(error)
          }
        )
      })
    },
    provinces ({commit, dispatch}, payload) {
      return new Promise((resolve, reject) => {
        Axios(API.endpoints.provinces + '?country_code=' + payload.country_code + '&search=' + payload.value).then(
          res => {
            commit('setProvinces', res.data)
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            return Promise.reject(error)
          }
        )
      })
    }
  }
}
